import { NgModule } from '@angular/core';
import { DeliverInPipe } from './deliver-in/deliver-in.pipe';
import { ProductIsAvailablePipe } from './product-is-available/product-is-available.pipe';

@NgModule({
  declarations: [DeliverInPipe, ProductIsAvailablePipe],
  exports: [DeliverInPipe, ProductIsAvailablePipe],
})
export class ProductPipesModule {}
